// extracted by mini-css-extract-plugin
module.exports = {"cornerSprite":"style__cornerSprite__COGZ2","sideSprite":"style__sideSprite__gDhyZ","middleSprite":"style__middleSprite__9RGcp"};